<template>
   <div class="banner">
     <mt-swipe :auto="4000">
      <mt-swipe-item v-for="banner in banners" :key="banner.id">
        <img :src="banner.banner?banner.banner:banner.listPic" class="banner_pic" />
      </mt-swipe-item>
  </mt-swipe>
  </div>
</template>
<script type = "text/ecamscript-6">
  import Vue from 'vue'
  import { Swipe, SwipeItem } from 'mint-ui'
  Vue.component(Swipe.name, Swipe)
  Vue.component(SwipeItem.name, SwipeItem)
  export default {
    name:'banner',
    data(){
      return {
        banners:[]
      }
    },
    created:function(){
      this.login()
    },
    methods:{
      login () {
        let params = {
            page:"1",
            pageSize:"10",
            order:"addTime"
        }
        let url ="api/getWelfareList.php?sponserCatalogid=0&page=1&pageSize=6 "
        this.$ajax.autoService
            .login(url)
            .then((res) => {
              this.banners = res.data;

            }, (res) => {
                console.log("error")
            })
       },
    }

  }
</script>
<style lang="stylus">
  .banner
   width:100%
   height:418px;
   position:relative
   .banner_pic
     width:100%
     height:418px;


</style>



// WEBPACK FOOTER //
// src/components/goodsCoupon/banner.vue